import { cn, panelCard } from "@pax/ui";

export function PaymentsClosedNote({ reason, className }: { reason: string; className?: string }) {
  return <p className={cn(panelCard, "p-3 text-sm text-muted-foreground", className)}>{reason}</p>;
}
